<template>
  <div>

    <section class="hero is-primary is-medium">
      <div class="hero-body has-text-centered">
        <div class="container">
        <h1 class="title">
          The Easiest Way to Get Insights From Your Audience
        </h1>
        <h2 class="subtitle">
          Start with 25 surveys, 1000 ratings and 5 text feedback on me, and then subscribe to the professional plan once you're happy.
        </h2>

        </div>
      </div>
    </section>
    <section class="section mt-4">
      <div class="container">

        <div class="field has-text-centered  ">
          <input id="pricingSwitch" type="checkbox" name="pricingSwitch" class="switch" v-model="yearly">
          <label v-if="yearly" for="pricingSwitch"><b>Yearly Prices</b> <span class="tag mr-4 is-light is-medium is-success"><b>4 months off 🎉</b></span></label>
          <label v-else for="pricingSwitch">Monthly Prices</label>
        </div>
        <p class="has-text-centered is-size-7"><br>Sold by our resell partner Paddle. Secure and
    industry-trusted. Excluding EU VAT or local sales taxes if applicable
        </p>
        <div class="pricing-table mt-6">
          <div class="pricing-plan">
            <div class="plan-header">Hobby</div>
            <div class="plan-price"><span class="plan-price-amount">Free</span></div>
            <div class="plan-items">
              <div class="plan-item"><span class="has-text-success has-text-weight-bold is-size-5">&check;</span> 25 Surveys</div>
              <div class="plan-item"><span class="has-text-success has-text-weight-bold is-size-5">&check;</span> 1000 ratings</div>
              <div class="plan-item"><span class="has-text-success has-text-weight-bold is-size-5">&check;</span><b-tooltip
                    label="It continues collecting when you hit the limit but you will not see more than 5 in total."
                    multilined position="is-right">
                     5 text responses
                  </b-tooltip></div>
              <div class="plan-item"><span class="has-text-danger has-text-weight-bold is-size-5">&times;</span> <del> Audio responses</del></div>
              <div class="plan-item"><span class="has-text-danger has-text-weight-bold is-size-5">&times;</span> <b-tooltip
                    label="You can remove the FeedLetter branding in any widget."
                    multilined position="is-right">
                    <del>Remove Branding</del>
                  </b-tooltip></div>
              <div class="plan-item"><span class="has-text-success has-text-weight-bold is-size-5">&check;</span>
                  <b-tooltip
                    label="You can edit basic texts but not all."
                    multilined position="is-right">
                    Basic customization
                  </b-tooltip>
              </div>
              <div class="plan-item"><span class="has-text-success has-text-weight-bold is-size-5">&check;</span> 1 Wall of Love</div>
              <div class="plan-item"><span class="has-text-success has-text-weight-bold is-size-5">&check;</span> 3 feedbacks per Wall of Love</div>
              <div class="plan-item"><span class="has-text-success has-text-weight-bold is-size-5">&check;</span> 1 Account-seat</div>
              
            </div>
            <div v-if="loggedIn" class="plan-footer">
              <button v-if="!subscribed" class="button is-fullwidth" disabled="disabled">Current plan</button>
              <a v-else class="button is-fullwidth" :href="user.app_metadata.cancel_url" target="_blank">Downgrade</a>
            </div>
            <div v-else class="plan-footer">
              <router-link v-if="!user.isLoggedIn"  class="button is-fullwidth" to="/register">Get Started</router-link>
            </div>

          </div>

          <div class="pricing-plan is-active is-success">
            <div class="plan-header">Professional</div>
            <div v-if="yearly" class="plan-price"><span class="plan-price-amount"><span class="plan-price-currency">$</span>13</span>/month <br>billed yearly: $156 </div>
            <div v-else class="plan-price"><span class="plan-price-amount"><span class="plan-price-currency">$</span>19</span>/month</div>
            <div class="plan-items">
              <div class="plan-item"><span class="has-text-success has-text-weight-bold is-size-5">&check;</span> Unlimited surveys</div>
              <div class="plan-item"><span class="has-text-success has-text-weight-bold is-size-5">&check;</span> Unlimited ratings</div>
              <div class="plan-item"><span class="has-text-success has-text-weight-bold is-size-5">&check;</span> Unlimited text responses</div>
              <div class="plan-item"><span class="has-text-success has-text-weight-bold is-size-5">&check;</span> Unlimited audio responses</div>
              <div class="plan-item"><span class="has-text-success has-text-weight-bold is-size-5">&check;</span> Remove Branding</div>
              <div class="plan-item"><span class="has-text-success has-text-weight-bold is-size-5">&check;</span> Full customization of reader-facing texts</div>
              <div class="plan-item"><span class="has-text-success has-text-weight-bold is-size-5">&check;</span> 3 Walls of Love</div>
              <div class="plan-item"><span class="has-text-success has-text-weight-bold is-size-5">&check;</span> 23 feedbacks per Wall of Love</div>
              <div class="plan-item"><span class="has-text-success has-text-weight-bold is-size-5">&check;</span> 2 Account-seats</div>
              <div class="plan-item"><span class="has-text-success has-text-weight-bold is-size-5">&check;</span> Export feedback & newsletter performance</div>
              <div class="plan-item"><span class="has-text-success has-text-weight-bold is-size-5">&check;</span> Email notifications</div>
              <div class="plan-item"><span class="has-text-danger has-text-weight-bold is-size-5">&times;</span> <del>Webhook notifications</del></div>
              <div class="plan-item"><span class="has-text-danger has-text-weight-bold is-size-5">&times;</span> <del>API</del></div>

              
            </div>
            <div v-if="subscribed && account.has_pro_plan" class="plan-footer">
              <button  class="button is-fullwidth" disabled="disabled">Current plan</button>
            </div>
            <div v-else class="plan-footer">
              <button v-if="yearly" class="button is-fullwidth" @click.prevent="buyEarlySupporter">Choose</button>
              <button v-else class="button is-fullwidth" @click.prevent="buyEarlySupporterMonthly">Choose</button>
            </div>
          </div>
          <div class="pricing-plan  is-primary">
            <div class="plan-header">Business</div>
            <div v-if="yearly" class="plan-price"><span class="plan-price-amount"><span class="plan-price-currency">$</span>33</span>/month <br>billed yearly: $392 </div>
            <div v-else class="plan-price"><span class="plan-price-amount"><span class="plan-price-currency">$</span>49</span>/month</div>

            <div class="plan-items">
              <div class="plan-item"><span class="has-text-success has-text-weight-bold is-size-5">&check;</span> Unlimited surveys</div>
              <div class="plan-item"><span class="has-text-success has-text-weight-bold is-size-5">&check;</span> Unlimited ratings</div>
              <div class="plan-item"><span class="has-text-success has-text-weight-bold is-size-5">&check;</span> Unlimited text responses</div>
              <div class="plan-item"><span class="has-text-success has-text-weight-bold is-size-5">&check;</span> Unlimited audio responses</div>
              <div class="plan-item"><span class="has-text-success has-text-weight-bold is-size-5">&check;</span> Remove Branding</div>
              <div class="plan-item"><span class="has-text-success has-text-weight-bold is-size-5">&check;</span> Full customization of reader-facing texts</div>
              <div class="plan-item"><span class="has-text-success has-text-weight-bold is-size-5">&check;</span> Unlimited Walls of Love</div>
              <div class="plan-item"><span class="has-text-success has-text-weight-bold is-size-5">&check;</span> 1000 feedbacks per Wall of Love</div>
              <div class="plan-item"><span class="has-text-success has-text-weight-bold is-size-5">&check;</span> 5 Account-seats</div>
              <div class="plan-item"><span class="has-text-success has-text-weight-bold is-size-5">&check;</span> Export feedback & newsletter performance</div>
              <div class="plan-item"><span class="has-text-success has-text-weight-bold is-size-5">&check;</span> Email notifications</div>
              <div class="plan-item"><span class="has-text-success has-text-weight-bold is-size-5">&check;</span>Webhook notifications</div>
              <div class="plan-item"><span class="has-text-success has-text-weight-bold is-size-5">&check;</span>API</div>

              
            </div>
            <div v-if="subscribed && account.has_biz_plan" class="plan-footer">
              <button  class="button is-fullwidth" disabled="disabled">Current plan</button>
            </div>
            <div v-else class="plan-footer">
              <button v-if="yearly" class="button is-fullwidth" @click.prevent="buyBizYearly">Choose</button>
              <button v-else class="button is-fullwidth" @click.prevent="buyBizMonthly">Choose</button>

            </div>
          </div>
        </div>




      </div>
    </section>
    <section class="section mt-4">
      <div class="container">
<h2 class="subtitle has-text-centered my-6">Detailed Features and Plans Comparison</h2>
<div class="table-container">
        <table class="table is-fullwidth">
  <thead>
    <tr>
      <th>Feature</th>
      <th>Hobby</th>
      <th>Professional</th>
      <th>Business</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td><b-tooltip label="The core to collect feedback. You create one per email you send on your newsletter or per question you collect using the web widget or onetime poll." multilined position="is-right">Number of Surveys</b-tooltip></td>
      <td>25</td>
      <td>Unlimited</td>
      <td>Unlimited</td>
    </tr>
    <tr>
      <td><b-tooltip label="A rating aka voting response is a simple vote when a reader clicked on a voting option." multilined position="is-right">Number of rating responses</b-tooltip></td>
      <td>1000</td>
      <td>Unlimited</td>
      <td>Unlimited</td>
    </tr>
    <tr>
      <td><b-tooltip label="Your readers can leave additional comments after the simple vote. It's where the gold lies." multilined position="is-right">Number of text responses</b-tooltip></td>
      <td><b-tooltip label="It continues collecting when you hit the limit but you will not see more than 5 in total." multilined position="is-right">5</b-tooltip></td>
      <td>Unlimited</td>
      <td>Unlimited</td>
    </tr>
    <tr>
      <td><b-tooltip label="Your readers can leave additional audio comments after the simple vote. It's where the gold lies." multilined position="is-right">Number of audio responses</b-tooltip></td>
      <td>×</td>
      <td>Unlimited</td>
      <td>Unlimited</td>
    </tr>

    <tr class="has-background-light">
      <td colspan="4">Survey Types</td>
    </tr>
    <tr>
      <td><b-tooltip label="Collect feedback in your newsletter with a minimal 3-thumbs voting and see how it performs over time" multilined position="is-right">3-Thumbs Newsletter Feedback</b-tooltip></td>
      <td>✓</td>
      <td>✓</td>
      <td>✓</td>
    </tr>
    <tr>
      <td><b-tooltip label="Send onetime polls to survey your readers. Up to 5 options per poll. Emoji Support" multilined position="is-right">Onetime Polls</b-tooltip></td>
      <td>✓ 3 options only</td>
      <td>✓ Up to 5 options</td>
      <td>✓ Up to 5 options</td>
    </tr>
    <tr>
      <td><b-tooltip label="The web rating widgets let's you collect feedback on your web sites or web apps using a 3-thumbs, 5-emoji or 5-star rating." multilined position="is-right">Web Rating Widget (3-Thumbs, 5-Emoji or 5-Star)</b-tooltip></td>
      <td>✓</td>
      <td>✓</td>
      <td>✓</td>
    </tr>
    <tr>
      <td><b-tooltip label="Adds a Google Search Rich Snippet for reviews to show an aggregated review rating on Google Search" multilined position="is-right">Rich Search Snippets for Reviews</b-tooltip></td>
      <td>×</td>
      <td>✓</td>
      <td>✓</td>
    </tr>

    <tr class="has-background-light">
      <td colspan="4"><b>Customization</b></td>
    </tr>
    <tr>
      <td><b-tooltip label="You can remove the FeedLetter branding in the widgets." multilined position="is-right">Remove Branding</b-tooltip></td>
      <td>×</td>
      <td>✓</td>
      <td>✓</td>
    </tr>
    <tr>
      <td><b-tooltip label="Customize reader facing texts like the voting section, the extended feedback page, thank you page or the web widget." multilined position="is-right">Customize all reader-facing texts</b-tooltip></td>
      <td><b-tooltip label="You can edit some reader-facing texts but not all." multilined position="is-right">Basic</b-tooltip></td>
      <td><b-tooltip label="Change all reader-facing texts and write in the slang, jargon or language of your newsletter." multilined position="is-right">✓</b-tooltip></td>
      <td><b-tooltip label="Change all reader-facing texts and write in the slang, jargon or language of your newsletter." multilined position="is-right">✓</b-tooltip></td>
    </tr>
    <tr>
      <td><b-tooltip label="All reader facing texts can be shown in a different language than English" multilined position="is-right">Localize all reader-facing texts</b-tooltip></td>
      <td>English Only</td>
      <td><b-tooltip label="Change all reader facing texts to the language of your newsletter. Write in Portuguese, Dutch, English or your language." multilined position="is-right">✓ any language</b-tooltip></td>
      <td><b-tooltip label="Change all reader facing texts to the language of your newsletter. Write in Portuguese, Dutch, English or your language." multilined position="is-right">✓ any language</b-tooltip></td>
    </tr>
    <tr>
      <td><b-tooltip label="A Thank You Page is shown to the reader after they wrote additional feedback." multilined position="is-right">Thank You Page</b-tooltip></td>
      <td><b-tooltip label="A simple thank you page with two lines of copy. You can change the texts." multilined position="is-right">Simple</b-tooltip></td>
      <td><b-tooltip label="As the free version PLUS you can redirect to an external page." multilined position="is-right">Full customization incl. redirect</b-tooltip></td>
      <td><b-tooltip label="As the free version PLUS you can redirect to an external page." multilined position="is-right">Full customization incl. redirect</b-tooltip></td>
    </tr>

    <tr class="has-background-light">
      <td colspan="4"><b>Wall of Love</b></td>
    </tr>
    <tr>
      <td><b-tooltip label="Embed script for a wall of love of all the text feedback you received." multilined position="is-right">Wall Of Love embed</b-tooltip></td>
      <td>✓</td>
      <td>✓</td>
      <td>✓</td>
    </tr>
    <tr>
      <td><b-tooltip label="The number of Wall of Love." multilined position="is-right">Number of Walls Of Love</b-tooltip></td>
      <td>1</td>
      <td>3</td>
      <td>Unlimited</td>
    </tr>
    <tr>
      <td><b-tooltip label="The number of feedback you can display on the Wall of Love embed." multilined position="is-right">Number of feedback on a single Wall Of Love</b-tooltip></td>
      <td>3</td>
      <td>23</td>
      <td>1000</td>
    </tr>
    <tr class="has-background-light">
      <td colspan="4"><b>Team Support</b></td>
    </tr>
    <tr>
      <td><b-tooltip label="Invite team members into your account. Members have full rights except for some account settings, billing details, and team member management." multilined position="is-right">Number of Account-seats</b-tooltip></td>
      <td>1</td>
      <td>2</td>
      <td>5</td>
    </tr>
    <tr class="has-background-light">
      <td colspan="4"><b>Reports</b></td>
    </tr>
    <tr>
      <td><b-tooltip label="Your newsletter performance and best sending times in a glimpse" multilined position="is-right">Newsletter Dashboard</b-tooltip></td>
      <td>✓</td>
      <td>✓</td>
      <td>✓</td>
    </tr>
    <tr>
      <td><b-tooltip label="Compare the performance of your recent newsletters" multilined position="is-right">Recent Newsletter Performance</b-tooltip></td>
      <td>✓</td>
      <td>✓</td>
      <td>✓</td>
    </tr>
    <tr>
      <td><b-tooltip label="Export all feedback as CSV" multilined position="is-right">Export Feedback</b-tooltip></td>
      <td>×</td>
      <td>✓</td>
      <td>✓</td>
    </tr>
    <tr>
      <td><b-tooltip label="Export newsletter performance as CSV" multilined position="is-right">Export newsletter performance report</b-tooltip></td>
      <td>×</td>
      <td>✓</td>
      <td>✓</td>
    </tr>
    <tr class="has-background-light">
      <td colspan="4"><b>Integrations</b></td>
    </tr>
    <tr>
      <td><b-tooltip label="Receive an email notification when a new text or audio feedback is posted." multilined position="is-right">Email notifications</b-tooltip></td>
      <td>×</td>
      <td>✓</td>
      <td>✓</td>
    </tr>
    <tr>
      <td><b-tooltip label="Receive new feedback via a webhook and automate using Zapier, Integromat or Make" multilined position="is-right">Webhook notifications</b-tooltip></td>
      <td>×</td>
      <td>×</td>
      <td>✓</td>
    </tr>
    <tr>
      <td><b-tooltip label="API for integrations. Upcoming feature." multilined position="is-right">API (BETA)</b-tooltip></td>
      <td>×</td>
      <td>×</td>
      <td>✓</td>
    </tr>
    <tr>
      <td></td>
      <td class="pt-6">
            <div v-if="loggedIn" >
              <button v-if="!subscribed" class="button is-fullwidth" disabled="disabled">Current plan</button>
              <a v-else class="button is-fullwidth" :href="user.app_metadata.cancel_url" target="_blank">Downgrade</a>
            </div>
            <div v-else >
              <router-link v-if="!user.isLoggedIn"  class="button is-fullwidth" to="/register">Get Started</router-link>
            </div>
      </td>
      <td  class="pt-6">
                    <div v-if="subscribed && account.has_pro_plan">
              <button  class="button is-fullwidth is-primary" disabled="disabled">Current plan</button>
            </div>
            <div v-else >
              <button v-if="yearly" class="button is-fullwidth is-primary" @click.prevent="buyEarlySupporter">Choose</button>
              <button v-else class="button is-fullwidth is-primary" @click.prevent="buyEarlySupporterMonthly">Choose</button>
            </div>
      </td>
      <td class="pt-6">
            <div v-if="subscribed && account.has_biz_plan" >
              <button  class="button is-fullwidth" disabled="disabled">Current plan</button>
            </div>
            <div v-else >
              <button v-if="yearly" class="button is-fullwidth " @click.prevent="buyBizYearly">Choose</button>
              <button v-else class="button is-fullwidth" @click.prevent="buyBizMonthly">Choose</button>

            </div>
      </td>
    </tr>
  </tbody>
</table>
</div>
      </div>
    </section>
    <section class="hero mt-6">
      <div class="hero-body has-text-centered">
        <h2 class="title">
          FeedLetter Wall of Love
        </h2>
        <h3 class="subtitle">
          My users are newsletter creators from tiny to large email lists, startups, freelancers and many more
        </h3>
        <div>
        <p class="starability-result" data-rating="5">
          Rated: 5/5 (99 votes)
        </p>
        &empty; 5/5 (99 votes)
        </div>
      </div>
    </section>

    <WallOfLoveSection />


    <section class="section mt-4">
      <div class="container">
        <div class="columns is-centered">
          <div class="column is-8">
            <div class="content is-medium">
              <h2 class="has-text-centered" id="faq">Frequently Asked Questions (FAQ)</h2>

<h3 id="how-many-forms-do-i-need" class="has-text-centered">How Many Forms Do I Need?</h3>

<p>You&#39;ll need one form for the Newsletter Feedback for each email you send. If you write once a week, you&#39;ll need 52 forms for the years (and fear not, they are easy to create).</p>

<p>You can almost test it for half a year with the free tier and experience yourself what result it brings.</p>

<h3 class="has-text-centered" id="does-it-work-with-my-email-provider-what-are-the-technical-requirements">Does It Work With My Email Provider? What Are the Technical Requirements?</h3>

<p>The Newsletter Feedback widget works with plain links, and you can copy and paste it into any place that supports links. I don&#39;t know of any email provider that does not support pasting formatted text with links or allows you to add a simple HTML snippet. The major player all support this out of the box and the smaller ones too.</p>

<p>The same applies to the One-time Poll widgets. You can use them anywhere where you can insert a link. It works in newsletters, on websites, and I am even using them in ebooks. And yes, readers actually answer them in my books.</p>

<p>The Web Rating widget works at any place where you can insert an HTML snippet. It uses Javascript and is pretty tiny for not to impact site performance.</p>

<h3 class="has-text-centered" id="what-is-the-difference-between-voting-and-textaudio-feedback">What Is the Difference Between Voting and Text/Audio Feedback?</h3>

<p>FeedLetter works with a 2-step process to maximize readers like to leave a response. The first step is simple voting, for example, a 3-thumbs for the Newsletter Feedback. You&#39;ll see them as votes in the analytics.</p>

<p>After voting, the reader can leave you additional feedback by filling out a textbox or leave an audio message, aka Text Responses - Audio Responses. It&#39;s the goldmine where your readers where tell you what they like or dislike and why.</p>

<h3 class="has-text-centered" id="does-it-stop-recording-responses-when-i-hit-the-limit">Does It Stop Recording Responses When I Hit the Limit?</h3>

<p>No. It will continue to record all readers&#39; responses when you hit the limit. However, you will not be able to read them in the analytics.</p>

<h3 class="has-text-centered" id="does-it-support-my-language">Does It Support My Language?</h3>

<p>The default texts are all written in English, but you can change any reader-facing text on the Professional and Business plans. I handle text in UTF-8, and most common languages are covered.</p>

<p>Some customers write in English, Portuguese, Dutch or German. </p>

<h3 class="has-text-centered" id="can-i-customize-the-texts">Can I customize the texts?</h3>

<p>Yes. You can change all reader-facing texts with the Professional and Business plans. It&#39;s limited on the free plan, though.</p>

<h3 class="has-text-centered" id="do-you-offer-parity-pricing">Do you offer parity support?</h3>

<p>Yes, I do. If you live in a place where USD is a ton of money, message me, and we&#39;ll find a way that works for both of us.</p>

<h3 class="has-text-centered" id="still-questions">Still Having Questions?</h3>

<p>If you still have questions, email me at hello@feedletter.co . I&#39;ll answer them.</p>

            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// @ is an alias to /src
import WallOfLoveSection from "@/components/WallOfLoveSection.vue";
import UpgradeSuccessForm from "@/components/UpgradeSuccessForm.vue";
import { mapState } from 'vuex'
import {trackEvent}  from "../lib/flevents"

export default {
  name: "Upgrade",
  components: { WallOfLoveSection},
  data: function () {
    return {
      feedbackForms: [],
      recentFeedback: [],
      searchTerm: null,
      isLoading:false,
      isLoadingRecentFeedback:false,
      yearly: true,
      loggedIn: true
    };
  },
  computed: {
    ...mapState([
      "user",
      "account"
    ]),
    subscribed() {
      return this.account.subscribed;
    },
  },
  mounted: function () {
    if (!this.user.isLoggedIn) {
      this.loggedIn = false
    } else {
      trackEvent(this.$store.state.user.id, "upgrade-view")
    }
    //this.showSuccessModal()
  },
  methods: {
    openBuyOverlay: function(planId, planLabel="Pro") {
        console.log(this.account.id)

        if(!this.loggedIn) {
          this.$buefy.dialog.alert("<p>Please log into your account first. </p><p class='mt-3'>Don't have one?</p><p  class='mt-3'> <a href='/register'>Sign Up for Free Now</a></p>")
          return
        }

        var self = this
        Paddle.Setup({ 
          vendor: 8205,
          eventCallback: function(data) {
            //console.log(data.event); // The data.event will specify the event type
            //console.log(data.eventData); // Data specifics on the event
            if(data.event === "Checkout.Complete") {
              self.$store.commit("SET_SUBSCRIBED", true)
              self.$store.commit("SET_SUBSCRIPTION_PLAN_ATTRIBUTES", planId)
              self.showSuccessModal(planLabel)
            }
          }
        });
        Paddle.Checkout.open({
          product: planId,
          passthrough: this.account.id,
        });
    },    
    buyBizYearly: function() {
      if(this.subscribed && this.account.has_pro_plan) {
        this.$buefy.dialog.alert("Changing from Professional to Business plan is not possible via self-service at the moment. Please contact me at hello@feedletter.co to switch.")
        return
      }
      this.openBuyOverlay(758628, "Business")
    },
    buyBizMonthly: function() {

      if(this.subscribed && this.account.has_pro_plan) {
        this.$buefy.dialog.alert("Changing from Professional to Business plan is not possible via self-service at the moment. Please contact me at hello@feedletter.co to switch.")
        return
      }

      this.openBuyOverlay(758627, "Business")
    },
      buyEarlySupporter: function() {
        if(this.subscribed && this.account.has_biz_plan) {
          this.$buefy.dialog.alert("Changing from Business to Professional plan is not possible via self-service at the moment. Please contact me at hello@feedletter.co to switch.")
          return
        }
        this.openBuyOverlay(889858)
    },
    showSuccessModal: function(planLabel) {
      this.$buefy.modal.open({
        parent: this,
        component: UpgradeSuccessForm,
        hasModalCard: false,
        canCancel: true,
        width: 640,
        trapFocus: true,
        props: {
          planLabel: planLabel
        }
      })
    },
    buyEarlySupporterMonthly: function() {
      if(this.subscribed && this.account.has_biz_plan) {
        this.$buefy.dialog.alert("Changing from Business to Professional plan is not possible via self-service at the moment. Please contact me at hello@feedletter.co to switch.")
        return
      }
      this.openBuyOverlay(883564)
    },
  },
};
</script>

<style scoped>


</style>